import React, { useEffect, useState } from 'react';
import { /* useDispatch, */ useSelector } from 'react-redux';

import { /*  MyThunkDispatch, */ RootState } from 'store';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import RejectedForm from 'screens/components/RejectedForm';
import { extractErrorMessage } from 'utils/generic';
import { useParams } from 'react-router-dom';
import { getRejectedReason } from 'services/resellerTravel';
import { DataTravelReason } from 'models/travelReseller';

const RejectedFormContainer = () => {
  /*   const dispatch: MyThunkDispatch = useDispatch(); */
  const { /* company, */ isLoading, error } = useSelector((state: RootState) => state.companyBilling);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const { rejectedReasonId } = useParams<{ rejectedReasonId?: string }>();
  const [rejectedReasonSelected, setRejectedReasonSelected] = useState<DataTravelReason | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (error) toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    console.log(rejectedReasonId);
    if (!rejectedReasonId) {
      setLoading(true);
      return;
    }
    getRejectedReasonId();
  }, []);

  const getRejectedReasonId = async () => {
    setLoading(false);
    try {
      const data = await getRejectedReason(rejectedReasonId);
      if (data) {
        setRejectedReasonSelected(data);
        setLoading(true);
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        // @ts-ignore
        message: error.message,
      });
      setLoading(false);
    }
  };
  return <>{loading && <RejectedForm isLoading={isLoading} rejectedReasonSelected={rejectedReasonSelected} />}</>;
};

export default RejectedFormContainer;
